import { call, put, takeEvery } from "redux-saga/effects";

import { AccountsCount, getAccountsCount } from "api/accounts";
import { setAccountsCounts } from "actions/skedCore";
import { SKED_CORE_GET_ACCOUNTS_ROUTINE } from "constants/ActionTypes";
import {
  addAccount,
  addAccounts,
  removeAccount,
  replaceAccount,
  replaceAllAccounts,
} from "../table";

const accountMutationActionTypes = [
  SKED_CORE_GET_ACCOUNTS_ROUTINE.SUCCESS,
  replaceAllAccounts.type,
  addAccount.type,
  addAccounts.type,
  replaceAccount.type,
  removeAccount.type,
];

export function* refreshAccountCounts() {
  try {
    const counts: AccountsCount = yield call(getAccountsCount);

    yield put(setAccountsCounts(counts));
  } catch {
    // Preserve the watcher so later account mutations still refresh counts.
  }
}

export function* watchAccountCountsBridgeRemoval() {
  yield takeEvery(accountMutationActionTypes, refreshAccountCounts);
}
